import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignupService } from '../services/signup.service';
import { TokenStorage } from '../../core/token.storage';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from '../../common/services/authorization.service';


@Component({
  selector: 'app-validate',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.css']
})
export class ValidateComponent implements OnInit {
constructor(private authorizationService: AuthorizationService, private router: Router, private authService: SignupService, private token: TokenStorage, private toastr: ToastrService) { 
             this.authorizationService.isAdmin();

}
  password: string;
  passwordConfirmation: string;
  validationCode: string
  validateForm: FormGroup;

    ngOnInit() {
        this.createForm();
    }

    private createForm() {
        this.validateForm = new FormGroup({
            // tslint:disable-next-line
            password: new FormControl('', Validators.required),
            passwordConfirmation: new FormControl('', Validators.required),
            validationCode: new FormControl('', Validators.required)
        });
    }

    validate(): void {
        if  (this.comparePassword()){
                this.authService.validateAccount(this.token.getUserID(), this.password, this.validationCode).subscribe(
                    (data) => {
                
                        if (data != null){
                                this.token.removeUserID();
                                this.showSuccess();
                                this.router.navigate(['login']);
                               
                        }
                        else
                        {
                        
                                this.showIDError();
                                this.router.navigate(['validation']);
                        }
                
                    }, 
                    (err) => { 
                        this.router.navigate(['validation']);
                        this.showError();
                    }
            

                );
            }
                    else
                    {
                        this.router.navigate(['validation']);
                        this.showPasswordError();
                    }
                }


     //
    comparePassword(): boolean {
        return (this.password == this.passwordConfirmation);
    }



    // For Toatr. 
    showSuccess() {
        this.toastr.success('Compte crée avec succès, veuillez entrer vos identifiants pour vous connecter!', 'Validation de compte');      
    }

      // For Toatr. 
    showError() {
        this.toastr.error('Erreur de validation!', 'Validation de compte');
      }

      // For Toatr. 
    showIDError() {
        this.toastr.error("Le code de validation saisie est incorrect.", 'Validation de compte');
      }
    // For Toatr. 
    showPasswordError() {
        this.toastr.error("Les deux mots de passe sont différents.", 'Validation de compte');
      }

}



// WEBPACK FOOTER //
// ./src/app/client-app/validate/validate.component.ts